import axios from 'axios';
import { useEffect, useState } from 'react'
import { getAccessToken, setDashboardCookies } from '../../services/authenticationService';
import { getMetaDataConfig } from '../../services/uiConfigService';
import { configurationAttributeType } from '../../types';

function SecondarySalesLensDashboard() {
  const [IFrameUrl,setIFrameUrl] = useState<string>("");
  useEffect(()=>{
    const displayDashboard = async ()=>{
      const token = getAccessToken() ?? "";
      const env = localStorage.getItem("env") ?? "prod";
      const viewMode="secondary"
      const portalConfig = await getMetaDataConfig("clientconfig", "portal_configuration");
      const portal_config: configurationAttributeType[] = portalConfig?.domainValues ?? [];
      const newSaleslensApi = portal_config?.find((item) => item.name === "newSaleslensApi")?.value ?? false;
      let url = "https://saleslens.salescode.ai/dashboard/session";
      if (newSaleslensApi) {
        url = "https://scprduisln.alsafidanone.com.sa/dashboard/session";
      }
      const resp = await axios.get(url,{
        headers: {
          Authorization: token
        },
        params: {
          env,viewMode
        }
      })
      if(resp.status>=200 && resp.status<300){
        const salesLensUrl = resp?.data?.url;
        setIFrameUrl(salesLensUrl)
      if(window.location.hostname.includes("salescode.ai")){
        // await setDashboardCookies();
        // window.open("https://saleslens.salescode.ai/dashboard");
      }else{
        if(salesLensUrl){
          window.open(salesLensUrl)
        }
        window.history.back();
      }
    }
      // window.history.back();
      
    }
    displayDashboard() ;
  },[]);

  return <>
  <iframe src={IFrameUrl} title="SalesLens" height="100%" width="100%" style={{"border":"0px"}}></iframe>
  </>
}

export default SecondarySalesLensDashboard;